module.exports = __webpack_public_path__ + "static/img/IMG_20160822_144053.4bcf4c6a.jpg";